import jsxElementToImgBase64 from "Common/componentUtils/jsxElementToImgBase64";
import { themeVariables } from "Components/theme";
import React from "react";
import { NODE_DEFAULT_SIZE, NODE_MAX_SIZE } from "../../constants";
import NodeLabel from "../../nodeLabel";
import createWebGL2NodeStyle from "./createWebGL2NodeStyle";
import SIZES from "./styleSizes";
import webGL2NodeStyles from "./webGL2NodeStyles";
const graphNodeLabelDetailedStyle = {
    paddingLeft: SIZES.IMG_PADDING,
    paddingRight: SIZES.IMG_PADDING,
    height: NODE_DEFAULT_SIZE.height,
    width: "100%",
    maxWidth: NODE_MAX_SIZE.width,
    maxHeight: NODE_MAX_SIZE.height,
    margin: 0,
    borderRadius: SIZES.NODE_ROUND_RADIUS,
    fontFamily: themeVariables["font-family-base"],
    fontSize: themeVariables["font-size-base"]
};
export default async (tag) => {
    const base64src = await jsxElementToImgBase64(React.createElement(NodeLabel, { imgSize: NODE_DEFAULT_SIZE.height - 2 * SIZES.IMG_PADDING, data: tag, style: graphNodeLabelDetailedStyle, whiteSpace: "nowrap" }), {
        w: SIZES.IMG_PADDING / 2,
        h: 0
    });
    if (base64src) {
        const style = await createWebGL2NodeStyle(base64src, undefined, undefined, 0, "round-rectangle");
        if (style) {
            webGL2NodeStyles.nodeIdMap[tag.Id] = {
                _default: style
            };
        }
    }
};
